import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "rows", "placeholder", "required"]


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTextArea',
  props: {
    modelValue: { default: "" },
    rows: {},
    full: { type: Boolean, default: true },
    required: { type: Boolean },
    placeholder: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const updateText = (event:Event) => emit("update:modelValue", (event?.target as HTMLInputElement).value);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    value: _ctx.modelValue,
    onInput: updateText,
    rows: _ctx.rows,
    placeholder: _ctx.placeholder,
    required: _ctx.required,
    class: _normalizeClass([[_ctx.full && 'w-full'], "shadow-sm focus:ring-sky-blue block w-full sm:text-sm border-1 rounded-none"])
  }, null, 42, _hoisted_1))
}
}

})